import TransactHeader from '@/components/transact/TransactHeader.vue';
import { Button } from '@yellowcard/components-library-vue3';
import useTransactionsStore from '@/store/modules/transactions';
import { usePaymentStore } from '@/store/modules/payment';
import { useGeneralStore } from '@/store/modules/general';
import { useAuthStore } from '@/store/modules/auth';
import * as QRCode from 'qrcode';
import { formatTime, numberFormat, getChannelLabel } from '@/utils/helpers';
import { storeToRefs } from 'pinia';
import { onMounted, ref, onUnmounted } from 'vue';
import { PaymentTypes } from '@/types/payment';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
export default {
    name: 'SellWalletDetails',
    components: {
        TransactHeader,
        Button,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { selectedCrypto, selectedCryptoAmount, payment, selectedCurrencyAmount, selectedChannel, } = storeToRefs(transactionStore);
        const paymentStore = usePaymentStore();
        const { currentStep } = storeToRefs(paymentStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const qrCodeUrl = ref(undefined);
        const walletAddress = ref(undefined);
        const walletTag = ref(undefined);
        const displayTimeRemaining = ref('');
        const timeToExpiry = ref(0);
        const intervalId = ref(undefined);
        const generalStore = useGeneralStore();
        const { showToast } = generalStore;
        const startTimer = () => {
            intervalId.value = window.setTimeout(() => {
                timeToExpiry.value -= 1;
                displayTimeRemaining.value = formatTime(timeToExpiry.value);
                if (timeToExpiry.value <= 0) {
                    clearInterval(intervalId.value);
                    displayTimeRemaining.value = '00:00s';
                }
                startTimer();
            }, 1000);
        };
        const copyWalletAddress = async () => {
            if (walletAddress.value) {
                await navigator.clipboard.writeText(walletAddress.value);
                showToast('Wallet address copied to clipboard');
            }
            return true;
        };
        const copyTag = async () => {
            if (walletTag.value) {
                await navigator.clipboard.writeText(walletTag.value);
                showToast('Wallet tag copied to clipboard');
            }
            return true;
        };
        const onKeyPress = () => {
            console.log();
        };
        const copyAmount = async () => {
            if (payment.value?.settlementInfo.cryptoAmount) {
                await navigator.clipboard.writeText(payment.value.settlementInfo.cryptoAmount.toString());
                showToast('Amount copied to clipboard');
            }
            return true;
        };
        const getQrCodeUrl = async (address, network) => {
            if (!address || !network)
                return;
            // will split out tag from address, note this will need to be updated if we add other tokens that require a tag
            if (network === 'TON') {
                const [isolatedAddress, tag] = address.split('_');
                walletAddress.value = isolatedAddress;
                walletTag.value = tag;
            }
            else {
                walletAddress.value = address;
            }
            qrCodeUrl.value = await QRCode.toDataURL(walletAddress.value);
        };
        onMounted(async () => {
            await getQrCodeUrl(payment.value?.settlementInfo.walletAddress ?? '', payment.value?.settlementInfo.cryptoNetwork ?? '');
            if (payment.value?.settlementInfo.expiresAt) {
                timeToExpiry.value = parseInt(String((new Date(payment.value?.settlementInfo.expiresAt).getTime() -
                    new Date().getTime()) /
                    1000), 10);
            }
            if (timeToExpiry.value > 0) {
                startTimer();
            }
            else {
                displayTimeRemaining.value = '00:00s';
            }
        });
        onUnmounted(() => {
            clearInterval(intervalId.value);
        });
        const showPaymentStatus = () => {
            trackEvent(MIXPANEL_EVENTS.SELL.CONFIRM_SENT_TOKEN, {
                partner: partnerId.value,
                payment_method: getChannelLabel(selectedChannel.value),
            });
            currentStep.value = PaymentTypes.SellPaymentSteps.PAYMENT_4;
        };
        return {
            selectedCrypto,
            selectedCryptoAmount,
            selectedCurrencyAmount,
            qrCodeUrl,
            walletAddress,
            displayTimeRemaining,
            payment,
            numberFormat,
            showPaymentStatus,
            copyWalletAddress,
            copyAmount,
            onKeyPress,
            walletTag,
            copyTag,
        };
    },
};
